import { DUKE_CAMPAIGN } from "./config";

export function getCommodityIconSrc(type) {
  const lowerCaseType = type.toLowerCase();
  switch (lowerCaseType) {
    case "wind":
      return "/icon/icon_wind.png";
    case "easy":
      return "/images/breathe_easy.png";
    case "solar":
      return "/icon/icon_solar.png";
    case "renewable":
      return "/icon/icon_green.svg";
    case "carbon offset":
      return "/images/icon_gas.png";
    case "eco rewards":
      return "/images/ecorewards.png";
    case "gas giveback":
      return "/images/gasgiveback.png";
    case "flexstart":
      return "/images/flexstart.png";
    case "duke":
      return "/images/BlueFlameCircle.png";
    case "free month 12":
      return "/images/freeMonth12.png";
    default:
      return "";
  }
}

export function getEcoOrGasNewPlansName(plan_name, utility) {
  // console.log({plan_name, utility})
  if (plan_name.toLowerCase().includes("eco rewards")) {
    return "eco rewards";
  } else if (plan_name.toLowerCase().includes("gas giveback")) {
    return "gas giveback";
  } else if (plan_name.toLowerCase().includes("flexstart")) {
    return "flexstart";
  } else if (plan_name.toLowerCase().includes("free month 12")) {
    return "free month 12";
  } else if (plan_name.toLowerCase().includes(DUKE_CAMPAIGN.toLowerCase())) {
    if (utility) {
      if (typeof utility == "string") {
        if (utility?.toLowerCase()?.includes("duke")) {
          return "duke";
        }
      } else if (typeof utility == "object") {
        if (utility?.name?.toLowerCase()?.includes("duke")) {
          return "duke";
        }
      }
    }
  } else return null;
}

// earth day promo
// IF THE UTILITYY IS ONE OF CenterPoint, Oncor, West Penn Power, Penelec, Penn Power, and PECO, returns TRUE
export function isEarthDayPromoActive(utilityList) {
  return false; // remove this line if eath day promo is active
  // eslint-disable-next-line no-unreachable
  if (
    !utilityList ||
    !utilityList.hasOwnProperty("Electric") ||
    !Array.isArray(utilityList["Electric"]) ||
    utilityList["Electric"].length === 0
  ) {
    return false;
  }
  return utilityList["Electric"].some((item) => {
    const utilityName = item.name.toLowerCase();
    return (
      utilityName.includes("centerpoint") ||
      utilityName.includes("oncor") ||
      utilityName.includes("west penn power") ||
      utilityName.includes("penelec") ||
      utilityName.includes("penn power") ||
      utilityName.includes("peco")
    );
  });
}

export function getUtilityTypeFromattedString(utilityType) {
  if (utilityType === "Electric") {
    return "Electricity";
  } else if (utilityType === "Gas") {
    return "Natural Gas";
  } else {
    return utilityType;
  }
}
